/**
 * card-discount-checker.js
 * Checks automatic discounts for product cards in "You May Also Like" and
 * "Best Sellers" through the shared StorefrontClient (global queue, unified
 * 1h cache, order-level guardrail).
 *
 * Single-variant: shows strikethrough original + sale price in orange.
 * Multi-variant: shows strikethrough original range + discounted range in dark red.
 */
(function () {
  'use strict';

  function formatMoney(amount) {
    return '$' + parseFloat(amount).toFixed(2);
  }

  function updateSingleVariantCard(card, discountInfo, prefix) {
    if (!discountInfo || !discountInfo.hasDiscount) return;

    var pricesEl = card.querySelector('.' + prefix + '__prices');
    if (!pricesEl) return;

    pricesEl.className = prefix + '__prices ' + prefix + '__prices--sale';
    pricesEl.innerHTML = '<span class="' + prefix + '__price ' + prefix + '__price--compare">' + formatMoney(discountInfo.originalPrice) + '</span>' +
                         '<span class="' + prefix + '__price ' + prefix + '__price--sale">' + formatMoney(discountInfo.finalPrice) + '</span>';
  }

  function updateMultiVariantCard(card, allResults, prefix) {
    var ids = (card.getAttribute('data-variant-ids') || '').split(',');
    var anyDiscount = false;
    var discountedPrices = [];

    for (var i = 0; i < ids.length; i++) {
      var info = allResults[ids[i]];
      if (info && info.hasDiscount) {
        anyDiscount = true;
        discountedPrices.push(info.finalPrice);
      } else if (info && info.originalPrice != null) {
        discountedPrices.push(info.originalPrice);
      }
    }

    if (!anyDiscount || discountedPrices.length === 0) return;

    var minDiscount = Math.min.apply(null, discountedPrices);
    var maxDiscount = Math.max.apply(null, discountedPrices);

    // Original range from data attributes (cents → dollars)
    var origMin = parseInt(card.getAttribute('data-price-min') || '0') / 100;
    var origMax = parseInt(card.getAttribute('data-price-max') || '0') / 100;

    var pricesEl = card.querySelector('.' + prefix + '__prices');
    if (!pricesEl) return;

    // Collapse to a single price when the range has no spread (all variants
    // share the same original price and the same discounted price).
    if (origMin === origMax && minDiscount === maxDiscount) {
      pricesEl.className = prefix + '__prices ' + prefix + '__prices--sale';
      pricesEl.innerHTML = '<span class="' + prefix + '__price ' + prefix + '__price--compare">' + formatMoney(origMin) + '</span>' +
                           '<span class="' + prefix + '__price ' + prefix + '__price--sale">' + formatMoney(minDiscount) + '</span>';
      return;
    }

    pricesEl.className = prefix + '__prices ' + prefix + '__prices--stacked';
    pricesEl.innerHTML = '<span class="' + prefix + '__price ' + prefix + '__price--range-compare">' + formatMoney(origMin) + ' - ' + formatMoney(origMax) + '</span>' +
                         '<span class="' + prefix + '__price ' + prefix + '__price--range-sale">' + formatMoney(minDiscount) + ' - ' + formatMoney(maxDiscount) + '</span>';
  }

  function processSection(selector, prefix) {
    var cards = document.querySelectorAll(selector);
    if (!cards.length) return;

    // Collect ALL variant IDs from all cards
    var allIds = [];
    var cardMap = []; // { card, ids[], isMulti }

    cards.forEach(function (card) {
      var idsAttr = card.getAttribute('data-variant-ids');
      if (!idsAttr) return;
      var ids = idsAttr.split(',').filter(Boolean);
      var isMulti = ids.length > 1;
      cardMap.push({ card: card, ids: ids, isMulti: isMulti });
      for (var i = 0; i < ids.length; i++) {
        if (allIds.indexOf(ids[i]) === -1) allIds.push(ids[i]);
      }
    });

    if (!allIds.length) return;

    // Resolve each product's OWN discount — getDiscountsIsolated peels the
    // winner across rounds so a higher-tier sale on one card doesn't suppress a
    // lower-tier sale on another (Shopify applies one automatic discount per
    // cart). Serves cache hits instantly (variants already seen on PLP/PDP).
    window.StorefrontClient.getDiscountsIsolated(allIds).then(function (map) {
      var allResults = {};
      map.forEach(function (info, id) {
        // null/unresolved = undetermined — leave the card's base price
        if (!info || info.unresolved) return;
        allResults[id] = info;
      });

      for (var i = 0; i < cardMap.length; i++) {
        var entry = cardMap[i];
        if (entry.isMulti) {
          updateMultiVariantCard(entry.card, allResults, prefix);
        } else if (entry.ids.length === 1) {
          updateSingleVariantCard(entry.card, allResults[entry.ids[0]], prefix);
        }
      }
    });
  }

  function init() {
    if (!window.StorefrontClient) return;
    processSection('.pdp-also-like__card', 'pdp-also-like');
    processSection('.best-sellers__card', 'best-sellers');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
